// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconAvailable: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="8" viewBox="0 0 11 8" fill="currentColor">
            <path
                fill="#999"
                d="M383,1208.8 C383,1209.0047 382.92327,1209.2095 382.76981,1209.3655 L376.484096,1215.7655 C376.33125,1215.9225 376.12991,1216 375.928571,1216 C375.727232,1216 375.526384,1215.92188 375.37317,1215.76562 L372.230313,1212.56562 C372.076853,1212.41 372,1212.205 372,1212 C372,1211.543 372.367076,1211.2 372.785714,1211.2 C372.986759,1211.2 373.187902,1211.27813 373.341116,1211.43438 L375.928572,1214.07 L381.659375,1208.235 C381.811607,1208.07825 382.012946,1208 382.214286,1208 C382.634152,1208 383,1208.3425 383,1208.8 L383,1208.8 Z"
                transform="translate(-372 -1208)"
            />
        </svg>
    );
};

export default React.memo(IconAvailable);
